var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.7,323v-67c0-11.8-9.6-21.3-21.3-21.3h-128V189c45.6-11.8,73.1-58.3,61.3-104s-58.3-73.1-104-61.3 s-73.1,58.3-61.3,104c7.8,30.1,31.2,53.5,61.3,61.3v45.7h-128c-11.8,0-21.3,9.6-21.3,21.3v67c-45.6,11.8-73.1,58.3-61.3,104 s58.3,73.1,104,61.3s73.1-58.3,61.3-104c-7.8-30.1-31.2-53.5-61.3-61.3v-45.7h256V323c-45.6,11.8-73.1,58.3-61.3,104 c11.8,45.6,58.3,73.1,104,61.3s73.1-58.3,61.3-104C480.2,354.2,456.7,330.7,426.7,323z M213.3,106.7c0-23.6,19.1-42.7,42.7-42.7 s42.7,19.1,42.7,42.7s-19.1,42.7-42.7,42.7S213.3,130.2,213.3,106.7z M149.3,405.3c0,23.6-19.1,42.7-42.7,42.7S64,428.9,64,405.3 s19.1-42.7,42.7-42.7S149.3,381.8,149.3,405.3z M405.3,448c-23.6,0-42.7-19.1-42.7-42.7s19.1-42.7,42.7-42.7s42.7,19.1,42.7,42.7 S428.9,448,405.3,448z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.e90b9e2e1733a40f8ab807728fa80e3d.svg";
export { ForwardRef as ReactComponent };